import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom'
import DropDown from '../CommonControlls/DropdownRendrer'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import jsPDF from 'jspdf'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class XpertSite_List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // Table
      data: [],
      page: 1,
      sizePerPage: 15,
      TotalRecord: 0,
      loading: false,
      exportLoading: false,

      permissions: [],

      sortField: 'id',
      idsortOrder: 'desc',
      provinceNamesortOrder: '',
      districtNamesortOrder: '',
      tehsilNamesortOrder: '',
      namesortOrder: '',

      FilteredSrs: [],

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => { },
        Second_Callback: () => { },
        type: 1,
      },

      SrList: [],
      SrId: 0,
      category: '',
      is_Microscope: false,

      ProvinceLoader: false,
      Provincelist: [],
      ProvinceId: [],

      DistrictLoader: false,
      Districtlist: [],
      FilteredDistrictlist: [],
      DistrictId: [],

      TehsilLoader: false,
      Tehsillist: [],
      FilteredTehsillist: [],
      TehsilId: [],

      exportingPdf: false,

      active: false,
      isActive: null,

      HCFTypelist: [
        { id: 0, name: 'RHC/PPM' },
        { id: 1, name: 'BHU/GP' },
      ],
      HCFTypeId: 0,
    }
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState(
      {
        [fieldId]: value,
        // isSaveSearch: this.state.isSearchChanged ? true : false
      },
      () => {
        if (fieldId === 'ProvinceId') {
          this.FilterDistricts(value)
        }
        if (fieldId === 'SrId') {
          const tempDistricts = this.state.Districtlist
          var filteredSelectedDistricts = tempDistricts.filter(
            (obj) => obj.subrecipientid === value,
          )
          this.setState({
            FilteredDistrictlist: filteredSelectedDistricts,
          })
        }
        if (fieldId === 'DistrictId') {
          this.FilterTehsils(value)
        }
      },
    )
  }
  FilterDistricts = (value) => {
    // filter ditrict list
    // var TempArr = this.state.Districtlist
    var selectedProvince = Common.ConvertToCommaSplitArray(value, 'id')
    // var filteredDistrictList = TempArr.filter(function (obj) {
    //     return selectedProvince.indexOf(obj.provinceId) > -1
    // });

    const tempSrs = this.state.SrList
    const filteredSrs = tempSrs.filter(
      (item) => selectedProvince.indexOf(item.provinceid) > -1,
    )

    // filter district selected values
    // var selectedDistricts = this.state.DistrictId
    // var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(filteredDistrictList, "id")
    // var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
    //     return filteredDistrictIdArr.indexOf(obj.id) > -1
    // });

    this.setState({
      // FilteredDistrictlist: filteredDistrictList,
      // DistrictId: filteredSelectedDistricts,
      FilteredSrs: filteredSrs,
    })
  }
  FilterTehsils = (value) => {
    // filter Tehsil list
    var TempArr = this.state.Tehsillist
    var selectedVale = Common.ConvertToCommaSplitArray(value, 'id')
    var filteredTehsilList = TempArr.filter(function (obj) {
      return selectedVale.indexOf(obj.districtId) > -1
    })

    // const TempSr = this.state.SrList
    // const filtered = TempSr.filter((el) => {
    //     return selectedVale.indexOf(el.districtId) > -1
    // })

    // filter Tehsil selected values
    var selectedTehsils = this.state.TehsilId
    var filteredTehsilIdArr = Common.ConvertToCommaSplitArray(
      filteredTehsilList,
      'id',
    )
    var filteredSelectedTehsils = selectedTehsils.filter(function (obj) {
      return filteredTehsilIdArr.indexOf(obj.id) > -1
    })

    this.setState({
      FilteredTehsillist: filteredTehsilList,
      TehsilId: filteredSelectedTehsils,
      // FilteredSrs: filtered
    })
  }

  render() {
    const CellMenu = (cell, row) => {
      return (
        <div>
          {this.state.permissions.includes('xpertsite-update') && (
            <Link to={'/XpertSite_Edit/' + row.id}>
              <button
                data-toggle="tooltip"
                title="Edit"
                class="btn TableRow_btn"
              >
                <i
                  class="fa fa-pencil-square-o text-primary"
                  aria-hidden="true"
                ></i>
              </button>
            </Link>
          )}
          {this.state.permissions.includes('xpertsite-delete') && (
            <button
              onClick={() => this.onDelete(row.id)}
              data-toggle="tooltip"
              title="Delete"
              class="btn TableRow_btn"
            >
              <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
            </button>
          )}
        </div>
      )
    }

    const columns = [
      {
        dataField: 'id',
        text: 'RFH ID',
        headerStyle: () => {
          return { width: '110px', fontSize: '13px' }
        },
        sort: true,
      },
      {
        dataField: "dhis2code",
        text: "DHIS2 ID",
        headerStyle: () => {
          return { width: "120px", fontSize: "13px" };
        },
        csvFormatter: (dhis2code) => (dhis2code == null ? "" : dhis2code),
      },
      {
        dataField: "miscode",
        text: "MIS ID",
        headerStyle: () => {
          return { width: "120px", fontSize: "13px" };
        },
        csvFormatter: (miscode) => (miscode == null ? "" : miscode),
      },
      {
        dataField: 'provinceName',
        text: 'Province',
        headerStyle: () => {
          return { width: '110px', fontSize: '13px' }
        },
        sort: true,
      },
      {
        dataField: 'subRecipient_ShortName',
        text: 'Sr. Name',
        headerStyle: () => {
          return { width: '90px', fontSize: '13px' }
        },
        sort: true,
      },
      {
        dataField: 'districtName',
        text: 'District',
        headerStyle: () => {
          return { width: '95px', fontSize: '13px' }
        },
        sort: true,
      },
      {
        dataField: 'tehsilName',
        text: 'Tehsil',
        headerStyle: () => {
          return { width: '90px', fontSize: '13px' }
        },
        sort: true,
      },
      {
        dataField: 'category',
        text: 'Category',
        headerStyle: () => {
          return { width: '90px', fontSize: '13px' }
        },
      },
      {
        dataField: 'isGeneXpert',
        text: 'Gene Xpert',
        headerStyle: () => {
          return { width: '90px', fontSize: '13px' }
        },
      },
      {
        dataField: 'samplesCountXpert',
        text: 'Samples',
        headerStyle: () => {
          return { width: '90px', fontSize: '13px' }
        },
      },

      {
        dataField: 'is_microscope',
        text: 'Microscope',
        headerStyle: () => {
          return { width: '100px', fontSize: '13px' }
        },
      },
      {
        dataField: 'type',
        text: 'Type',
        hidden: true,
        headerStyle: () => {
          return { width: '100px', fontSize: '13px' }
        },
      },
      {
        dataField: 'isActive',
        text: 'Active/Inactive',
        headerStyle: () => {
          return { width: '150px', fontSize: '13px' }
        },
      },

      {
        dataField: 'name',
        text: 'Xpert Site',
        headerStyle: () => {
          return { width: '150px', fontSize: '13px' }
        },
        sort: true,
      },
      {
        dataField: 'contact',
        text: 'Contact',
        headerStyle: () => {
          return { width: '80px', fontSize: '13px' }
        },
        csvFormatter: (contact) => (contact == null ? '' : contact),
        // sort: true,
      },
      {
        dataField: "latitude",
        text: "Latitude",
        headerStyle: () => {
          return { width: "80px", fontSize: "13px" };
        },
        csvFormatter: (latitude) => (latitude == null ? "" : latitude),
        // sort: true,
      },
      {
        dataField: "longitude",
        text: "Longitude",
        headerStyle: () => {
          return { width: "80px", fontSize: "13px" };
        },
        csvFormatter: (longitude) => (longitude == null ? "" : longitude),
        // sort: true,
      },
      {
        dataField: 'address',
        text: 'Address',
        headerStyle: () => {
          return { width: '190px', fontSize: '13px' }
        },
        csvFormatter: (contact) => (contact == null ? '' : contact),
        // sort: true,
      },
      {
        dataField: '',
        text: 'Actions',
        headerStyle: (colum, colIndex) => {
          return { width: '100px' }
        },
        formatter: (cell, row) => {
          return CellMenu(cell, row)
        },
        csvExport: false,
      },
    ]

    return (
      <div>
        <AlertModal {...this.state.alertModalData} />
        <MainLayout />
        <div id="right-panel" class="right-panel">
          <Topmenu
            PageTitle="Xpert Site"
            isShowAddBtn={this.state.permissions.includes('xpertsite-add')}
            AddBtnLabel="Add Xpert Site"
            AddBtnLink="/XpertSite_Add"
          />
          <div class="content">
            <div
              className="card"
              style={{
                marginBottom: '20px',
                background: 'none',
                boxShadow: 'none',
              }}
            >
              <div className="card-body row" style={{ padding: '0px' }}>
                <div className="widget-tabs-list">
                  <ul className="Cases-nav nav nav-tabs">
                    {this.state.permissions.includes('xpertsite-view') && (
                      <li>
                        <Link to="/Xpert_Sites" class="active show" >
                          Xpert Sites
                        </Link>
                      </li>
                    )}
                    {this.state.permissions.includes('xpertsiteProfile-view') && (
                      <li>
                        <Link to="/Xpert_SitesProfiles">
                          Xpert Sites Profiles
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <div class="Table_Search row">
                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">Province</label>
                    <DropDown
                      multi={true}
                      dropdownRenderer={true}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="ProvinceId"
                      options={this.state.Provincelist}
                      val={this.state.ProvinceId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.ProvinceLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={true}
                      placeholder="Select"
                    />
                  </div>

                  <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="">Sub Recipient</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="SrId"
                      options={this.state.FilteredSrs}
                      val={this.state.SrId}
                      addPlaceholder=""
                      disabled={false}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">District</label>
                    <DropDown
                      multi={true}
                      dropdownRenderer={true}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="DistrictId"
                      options={this.state.FilteredDistrictlist}
                      val={this.state.DistrictId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.DistrictLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={true}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">Tehsil</label>
                    <DropDown
                      multi={true}
                      dropdownRenderer={true}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="TehsilId"
                      options={this.state.FilteredTehsillist}
                      val={this.state.TehsilId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.TehsilLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={true}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">Xpert Site Name</label>
                    <input
                      autocomplete="off"
                      type="text"
                      class="form-control Search_InputField"
                      id="SearchName"
                      placeholder="Enter Xpert Site Name"
                    />
                  </div>

                  <div className="ormInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="">
                      <span style={{ color: 'red' }}>* </span>Category
                    </label>
                    <select
                      className="form-control"
                      onChange={(event) =>
                        this.setState({
                          category: event.target.value,
                        })
                      }
                    >
                      <option value="">All</option>
                      <option value="public">Public</option>
                      <option value="private">Private</option>
                    </select>
                  </div>

                  <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12"
                    hidden={true} >
                    <label htmlFor="">Type</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="HCFTypeId"
                      options={this.state.HCFTypelist}
                      val={this.state.HCFTypeId}
                      addPlaceholder=""
                      disabled={false}
                      loading={false}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="">Status</label>
                    <select
                      className="form-control"
                      value={this.state.isActive === null ? "" : this.state.isActive ? "true" : "false"}
                      onChange={(event) => {
                        const value = event.target.value;
                        this.setState({
                          isActive: value === "" ? null : value === "true",
                        });
                      }}
                    >
                      <option value="">All</option>
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                    </select>
                  </div>

                  <div
                    className="col-md-1"
                    style={{
                      marginTop: '43px',
                      marginLeft: '13px',
                      marginRight: '20px',
                    }}
                  >
                    <label className="CheckBox_container Roles_CheckBox">
                      <span>Microscope</span>
                      <input
                        type="checkbox"
                        onChange={(event) =>
                          this.setState({ is_Microscope: event.target.checked })
                        }
                      />
                      <span className="CheckBox_checkmark"></span>
                    </label>
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12" style={{ marginTop: '33px' }}>
                    <button
                      onClick={() => {
                        this.PopulateTable()
                      }}
                      id="FormSearchBtn"
                      class="btn btn-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>

                {/* <div class="TableTop_Buttons">
                        <span onClick={() => { $(".react-bs-table-csv-btn").click()}} class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

                <Table
                  keyField="id"
                  data={this.state.data}
                  page={this.state.page}
                  sizePerPage={this.state.sizePerPage}
                  totalSize={this.state.TotalRecord}
                  onTableChange={this.handleTableChange}
                  changeSizePerPage={(size) => {
                    setTimeout(() => {
                      this.setState({
                        exportLoading: true,
                      })
                      this.ExportData(size)
                    }, 1000)
                  }}
                  exportPdf={this.ExportPdf}
                  exportAllowed={this.state.permissions.includes(
                    'xpertsite-export',
                  )}
                  isPagination={true}
                  pdfExportLoading={this.state.exportingPdf}
                  columns={columns}
                  loading={this.state.loading}
                  RefreshTable={this.PopulateTable}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }

  componentDidMount() {
    Common.AddClassToMenueLink('MenuLink_XpertSites')
    this.GetPageConfigData(() => {
      this.PopulateTable()
    })
    $('.Search_InputField').on('keypress', (e) => {
      if (e.which === 13) {
        this.PopulateTable()
      }
    })

    this.SelectSubReciepents()

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_RolesPermissions,
      {
        pageSize: 15,
        pageNumber: 1,
      },
      (resp) => {
        const modifiedPermissions = resp.data
          .filter(
            (p) => p.permissioN_GROUP === 'XpertSite' && p.permissioN_ALLOWED,
          )
          .map((d) => d.permissioN_NAME)
        this.setState({ permissions: modifiedPermissions })
      },
    )
  }

  GetPageConfigData = (CallBack) => {
    this.props.ShowLoader({ Isloading: true })
    var d1 = $.Deferred()
    var d2 = $.Deferred()
    var d3 = $.Deferred()

    this.SelectProvinces(() => {
      d1.resolve()
    })
    this.SelectDistricts(() => {
      d2.resolve()
    })
    this.SelectTehsil(() => {
      d3.resolve()
    })

    $.when(d1, d2, d3).done(() => {
      this.props.ShowLoader({ Isloading: false })
      CallBack()
    })
  }
  SelectProvinces = (Callback) => {
    this.setState({ ProvinceLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Province,
      {},
      (data) => {
        this.setState({
          ProvinceLoader: false,
          Provincelist: data.data.sort(Common.compare),
        })
        Callback()
      },
      (error) => {
        this.setState({ ProvinceLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectDistricts = (Callback) => {
    this.setState({ DistrictLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      {},
      (data) => {
        this.setState({
          DistrictLoader: false,
          Districtlist: data.data.sort(Common.compare),
        })
        Callback()
      },
      (error) => {
        this.setState({ DistrictLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectTehsil = (Callback) => {
    this.setState({ TehsilLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Tehsil,
      {},
      (data) => {
        this.setState({
          TehsilLoader: false,
          Tehsillist: data.data.sort(Common.compare),
        })
        Callback()
      },
      (error) => {
        this.setState({ TehsilLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectSubReciepents = () => {
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectALl_SubRecipient,
      {},
      (resp) => {
        if (resp.status) {
          this.setState({
            SrList: resp.data.map((d) => ({
              id: d.id,
              name: d.short_name,
              ...d,
            })),
          })
        }
      },
    )
  }
  handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    if (type === 'sort') {
      let tempFieldorderLabel = sortField + 'sortOrder'
      let tempFieldorder =
        this.state[tempFieldorderLabel] === ''
          ? sortOrder
          : this.state[tempFieldorderLabel] === 'asc'
            ? 'desc'
            : 'asc'
      this.setState(
        {
          sortField,
          [tempFieldorderLabel]: tempFieldorder,
        },
        () => {
          this.PopulateTable()
        },
      )
      return
      // let result = this.state.data
      // // Handle column sort
      // if (sortOrder === 'asc') {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return 1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return -1;
      //     }
      //     return 0;
      //     });
      // } else {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return -1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return 1;
      //     }
      //     return 0;
      //     });
      // }
      // return
    }
    this.setState(
      {
        page,
        sizePerPage,
      },
      () => {
        this.PopulateTable()
      },
    )
  }
  ExportData = () => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    var provinceIdString =
      this.state.ProvinceId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.ProvinceId, 'id') + ','
    var districtIdString =
      this.state.DistrictId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.DistrictId, 'id') + ','
    var tehsilIdString =
      this.state.TehsilId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.TehsilId, 'id') + ','

    const parameters = {
      provinceIdString,
      districtIdString,
      tehsilIdString,
      pageSize: this.state.TotalRecord,
      pageNumber: 1,
      name: $('#SearchName').val(),
      category: this.state.category,
      isPaginate: true,
      ismicroscope: this.state.is_Microscope ? 1 : 0,
      isActive: this.state.isActive,
      subrecipientId: this.state.SrId,
      typeId: this.state.HCFTypeId,
    }
    Common.Ajax(
      this.props.UserAuthentication?.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_XpertSites,
      parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        if (resp.data.length > 0) {
          let { data } = resp
          // Map
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          var ProcessedDistrict = Common.ProcessDataInArray(
            this.state.Districtlist,
            'id',
          )
          var ProcessedTehsil = Common.ProcessDataInArray(
            this.state.Tehsillist,
            'id',
          )
          for (var i in data) {
            data[i].provinceName = ProcessedProvince[data[i].provinceId]?.name
            data[i].districtName = ProcessedDistrict[data[i].districtId]?.name
            data[i].tehsilName = ProcessedTehsil[data[i].tehsilId]?.name
          }

          // Sort
          if (this.state[this.state.sortField + 'sortOrder'] === 'asc') {
            data = data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return 1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return -1
              }
              return 0
            })
          } else {
            data = data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return -1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return 1
              }
              return 0
            })
          }
        }

        // Paginate
        var TotalRecord = resp.data.length
        this.setState({
          data: resp.data,
          TotalRecord,
          exportLoading: false,
        })
        $('.react-bs-table-csv-btn').click()
        setTimeout(() => {
          this.PopulateTable()
        }, 500)
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  ExportPdf = () => {
    const doc = new jsPDF()

    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ exportingPdf: true })
    var provinceIdString =
      this.state.ProvinceId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.ProvinceId, 'id') + ','
    var districtIdString =
      this.state.DistrictId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.DistrictId, 'id') + ','
    var tehsilIdString =
      this.state.TehsilId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.TehsilId, 'id') + ','

    const parameters = {
      provinceIdString,
      districtIdString,
      tehsilIdString,
      pageSize: this.state.TotalRecord,
      pageNumber: 1,
      name: $('#SearchName').val(),
      category: this.state.category,
      isPaginate: true,
      ismicroscope: this.state.is_Microscope ? 1 : 0,
      isActive: this.state.isActive,
      subrecipientId: this.state.SrId,
      typeId: this.state.HCFTypeId,
    }
    Common.Ajax(
      this.props.UserAuthentication?.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_XpertSites,
      parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        if (resp.data.length > 0) {
          let { data } = resp
          // Map
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          var ProcessedDistrict = Common.ProcessDataInArray(
            this.state.Districtlist,
            'id',
          )
          var ProcessedTehsil = Common.ProcessDataInArray(
            this.state.Tehsillist,
            'id',
          )
          for (var i in data) {
            data[i].provinceName = ProcessedProvince[data[i].provinceId]?.name
            data[i].districtName = ProcessedDistrict[data[i].districtId]?.name
            data[i].tehsilName = ProcessedTehsil[data[i].tehsilId]?.name
          }
        }

        doc.autoTable({
          theme: 'grid',
          body: [...resp.data],
          columns: [
            { header: 'id', dataKey: 'id' },
            { header: 'Name', dataKey: 'name' },
            { header: 'Address', dataKey: 'address' },
            { header: 'SR. Name', dataKey: 'subRecipient_ShortName' },
            { header: 'Category', dataKey: 'category' },
            { header: 'Province', dataKey: 'provinceName' },
            { header: 'Tehsil', dataKey: 'tehsilName' },
            { header: 'District', dataKey: 'districtName' },
            { header: 'Contact', dataKey: 'contact' },
          ],
        })

        this.setState({
          exportingPdf: false,
        })

        doc.save('xpertsites.pdf')
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  PopulateTable = () => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    var provinceIdString =
      this.state.ProvinceId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.ProvinceId, 'id') + ','
    var districtIdString =
      this.state.DistrictId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.DistrictId, 'id') + ','
    var tehsilIdString =
      this.state.TehsilId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.TehsilId, 'id') + ','

    const parameters = {
      provinceIdString,
      districtIdString,
      tehsilIdString,
      pageSize: this.state.sizePerPage,
      pageNumber: this.state.page,
      name: $('#SearchName').val(),
      category: this.state.category === '' ? null : this.state.category,
      isPaginate: true,
      ismicroscope: this.state.is_Microscope ? 1 : 0,
      isActive: this.state.isActive,
      subrecipientId: this.state.SrId,
      typeId: this.state.HCFTypeId,
    }
    Common.Ajax(
      this.props.UserAuthentication?.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_XpertSites,
      parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        if (resp.data.length > 0) {
          let { data } = resp
          // Map
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          var ProcessedDistrict = Common.ProcessDataInArray(
            this.state.Districtlist,
            'id',
          )
          var ProcessedTehsil = Common.ProcessDataInArray(
            this.state.Tehsillist,
            'id',
          )
          for (var i in data) {
            data[i].provinceName = ProcessedProvince[data[i].provinceId]?.name
            data[i].districtName = ProcessedDistrict[data[i].districtId]?.name
            data[i].tehsilName = ProcessedTehsil[data[i].tehsilId]?.name
          }
          // Sort
          if (this.state[this.state.sortField + 'sortOrder'] === 'asc') {
            data = data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return 1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return -1
              }
              return 0
            })
          } else {
            data = data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return -1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return 1
              }
              return 0
            })
          }
        }

        // Paginate
        var paginatedData = Common.paginate(
          resp.data,
          this.state.sizePerPage,
          this.state.page,
        )

        this.setState({
          data: resp.data,
          TotalRecord: resp.totalRecord,
          loading: false,
        })
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  onDelete = (id) => {
    this.setState(
      {
        alertModalData: {
          title: 'Delete Xpert Site',
          message: 'Are you sure you want to delete this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord(id)
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }
  DeleteRecord = (id) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Delete_XpertSites,
      { id: id },
      (Result) => {
        if (Result.status) {
          SyncConfig(
            () => {
              this.PopulateTable()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully.' })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(XpertSite_List)
